// removed by extract-text-webpack-plugin
module.exports = {"badge":"za3OZYlVqzRIm4Aa1lBGn","ellipse":"QLDeSt7rOngYtVH_9sTea","rectangle":"_3FZ5LD9PQwt0a9SY0NN40g","default":"_1fy3Y-MDq7SodYbEiPGlKY","primary":"BpiOAsCzGIJXxzN4nPEvl","success":"P2Dt4hSjcMM-uGWjHgaTJ","info":"bi51jgnyCnAn9E6eTx59x","warning":"_35CjUzVSpOwS2AYRATG21E","danger":"_3lLvGLAxCkAVsulM8UIx2O","top":"_3jx8bTh1Tk-IsgRYmnbqkx","middle":"_3DAhGF46HMHvgJ3GCHmRit","bottom":"_2zy8K2dB4GKc0OSksGxmRx"};


//////////////////
// WEBPACK FOOTER
// ./~/wix-style-react/dist/es/src/Badge/Badge.scss
// module id = ./node_modules/wix-style-react/dist/es/src/Badge/Badge.scss
// module chunks = 0